export enum RoleNameEnum {
  SUPER_ADMIN = 'G_SUPER_ADMIN',
  ADMIN = 'Admin',
  PATIENT = 'Patient',
  STAFF = 'Staff',
}
